import { Modal, Button } from "react-bootstrap";

const DeleteConfirmationModal = ({ show, onConfirm, onCancel, booking }) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the booking for{" "}
        <strong>{booking?.purpose}</strong> on {booking?.date} from{" "}
        {booking?.startTime} to {booking?.endTime}?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
